module.exports = __webpack_public_path__ + "static/media/walletpay-logo.93b9566b.png";